import * as DefinitionAccessors from './accessors';
import * as DefinitionConstants from './constants';
import * as DefinitionGenerators from './generators';
import * as DefinitionHacks from './hacks';
import * as DefinitionTypings from './typings';
import * as DefinitionUtils from './utils';
export * from './constants';
export * from './typings';
export { DefinitionAccessors, DefinitionGenerators, DefinitionHacks, DefinitionUtils };
export default Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, DefinitionAccessors), DefinitionConstants), DefinitionGenerators), DefinitionHacks), DefinitionTypings), DefinitionUtils);
